import { render, staticRenderFns } from "./CustomFieldsToolbar.vue?vue&type=template&id=c6808164"
import script from "./CustomFieldsToolbar.vue?vue&type=script&lang=js"
export * from "./CustomFieldsToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports